import { render, staticRenderFns } from "./addr.vue?vue&type=template&id=135cf9e0&scoped=true&"
import script from "./addr.vue?vue&type=script&lang=js&"
export * from "./addr.vue?vue&type=script&lang=js&"
import style0 from "./addr.vue?vue&type=style&index=0&id=135cf9e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135cf9e0",
  null
  
)

export default component.exports